import { lazy, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from '../components/layout/Layout';

const Home = lazy(() => import('../pages/Home'));
const About = lazy(() => import('../pages/About'));
const Services = lazy(() => import('../pages/Services'));
const ProjectsPage = lazy(() => import('../pages/ProjectsPage'));
const Team = lazy(() => import('../pages/Team'));
const Contact = lazy(() => import('../pages/Contact'));
const ServicePage = lazy(() => import('../pages/ServicePage'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('../pages/TermsOfService'));

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

const AppRoutes = () => (
  <>
    <ScrollToTop />
    <Routes>
      {/* Layout-wrapped routes */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="services" element={<Services />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="team" element={<Team />} />
        <Route path="contact" element={<Contact />} />
      </Route>

      {/* Dynamic service pages (outside layout - has own navbar) */}
      <Route path="/:city/:service" element={<ServicePage />} />

      {/* Legal pages (outside layout - has own navbar) */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />

      {/* Fallback to home */}
      <Route path="*" element={<Home />} />
    </Routes>
  </>
);

export default AppRoutes;
